import {
  IsArray,
  IsNotEmpty,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { Employee } from './employee.dto';

export class SaveCompanySignSettingsDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsString()
  @IsNotEmpty()
  signType: string;

  @ValidateNested({ each: true })
  @IsArray()
  @Type(() => Employee)
  employees: Employee[];

  @IsString()
  @IsNotEmpty()
  employeeSignTypeSource: string;
}
